import {
  EventNotificationSettingsDocument,
  useEventNotificationSettingsQuery,
  useUpdateEventNotificationSettingsMutation,
} from '@/suppliers/_gen/gql'

import useMsgs from '@/gf/hooks/useMsgs'
import useGqlClient from '@/suppliers/hooks/useGqlClient'

import EventNotificationSettingsTable, {
  EventNotificationSetting,
} from '@/gf/components/EventNotificationSettingsTable'

const EventNotificationSettings = ({ userId, notify }: { userId: string; notify: boolean }) => {
  const [_, msgr] = useMsgs()
  const client = useGqlClient()

  const { data } = useEventNotificationSettingsQuery({ variables: { userId }, client })

  const [update] = useUpdateEventNotificationSettingsMutation({
    client,
    refetchQueries: [EventNotificationSettingsDocument],
    awaitRefetchQueries: true,
  })

  const settings = data?.store.users?.[0]?.notificationSettings
  if (!settings) return null

  const save = (setting: EventNotificationSetting) =>
    update({ variables: { notificationSettings: [setting] } })
      .then(() => msgr.add('Notification settings saved.', 'positive'))
      .catch(() => msgr.addUnknownError())

  return <EventNotificationSettingsTable settings={settings} notify={notify} save={save} />
}

export default EventNotificationSettings
